<template>
  <!-- content -->
  <div class="c-px-1 c-pb-4 c-md:c-pb-6 c-lg:c-pb-0">
    <ReviewsList
      :product="product"
      :top-comments="topComments"
      :comments="comments"
    />
  </div>
</template>

<script setup>
import ReviewsList from '@/components/general/BaseReviewsList.vue'

defineProps({
  product: {
    type: Object,
    required: true,
  },

  topComments: {
    type: Array,
    required: true,
    default: () => [],
  },

  comments: {
    type: Array,
    required: true,
    default: () => [],
  },
})
</script>
